import { technicalIssuesCancelSelections } from '@lyrahealth-inc/shared-app-logic/src/features/sessions/endOfSession/endOfSessionConstants'

import { changeNoticeReasons, providerUnableToAttendReasonCancellation } from '../../common/constants/appConstants'

export default (clientFirstName: string, appointmentDate: string, inLateCancelWindow: boolean) => ({
  schema: {
    type: 'object',
    properties: {
      changeReason: {
        name: 'changeReason',
        type: 'string',
        title: 'Why are you canceling this session?',
        enum: inLateCancelWindow
          ? ['providerInitiated', 'clientTransition', 'clientCancel']
          : ['providerInitiated', 'clientTransition', 'clientInitiated'],
        enumNames: [
          'I am unable to attend this session',
          `${clientFirstName} transitioned to another program prior to the session`,
          `${clientFirstName} canceled this session`,
        ],
        validation: {
          isRequired: true,
        },
      },
      providerInitiated: {
        name: 'providerInitiated',
        type: 'string',
        title: 'What was the situation?',
        enum: providerUnableToAttendReasonCancellation(inLateCancelWindow).map(({ value }) => value),
        enumNames: providerUnableToAttendReasonCancellation(inLateCancelWindow).map(({ text }) => text),
        condition: {
          parentField: 'changeReason',
          parentValue: 'providerInitiated',
        },
        validation: {
          isRequired: true,
        },
      },
      providerInitiatedDetails: {
        name: 'providerInitiatedDetails',
        type: 'string',
        title: 'Additional details on this cancellation',
        condition: {
          parentField: 'providerInitiated',
          parentValue: 'providerUnableToAttendReasonOtherReason',
        },
        validation: {
          isRequired: true,
        },
      },
      changeNotice: {
        name: 'changeNotice',
        type: 'string',
        title: `Did ${clientFirstName} give you 24 hours notice?`,
        enum: ['clientInitiated', 'clientInitiatedReasonRequired'],
        enumNames: [
          `Yes, ${clientFirstName} reached out and requested a cancellation or reschedule more than 24 hours before the session`,
          'No (more options to follow)',
        ],
        condition: {
          parentField: 'changeReason',
          parentValue: 'clientCancel',
        },
        validation: {
          isRequired: true,
        },
      },
      changeNoticeDetail: {
        name: 'changeNoticeDetail',
        type: 'string',
        title: 'Reason',
        enum: changeNoticeReasons(clientFirstName).map(({ value }) => value),
        enumNames: changeNoticeReasons(clientFirstName).map(({ text }) => text),
        condition: {
          parentField: 'changeNotice',
          parentValue: 'clientInitiatedReasonRequired',
        },
        validation: {
          isRequired: true,
        },
      },
      technicalIssuesCancelSelection: {
        name: 'technicalIssuesCancelSelection',
        type: 'string',
        title:
          'Which of the following best describes the “technical issue” that prevented this session from occurring?',
        enum: technicalIssuesCancelSelections(clientFirstName).map(({ value }) => value),
        enumNames: technicalIssuesCancelSelections(clientFirstName).map(({ text }) => text),
        condition: {
          parentField: 'changeNoticeDetail',
          parentValue: 'technicalIssues',
        },
        validation: {
          isRequired: true,
        },
      },
      technicalIssuesCancelDetails: {
        name: 'technicalIssuesCancelDetails',
        type: 'string',
        title: 'Additional details on technical issue(s) experienced:',
        condition: {
          parentField: 'changeNoticeDetail',
          parentValue: 'technicalIssues',
        },
      },
    },
  },

  uiSchema: {
    'ui:order': [
      'title',
      'appointmentDate',
      'implicationMessage',
      'changeReason',
      'providerInitiated',
      'providerInitiatedDetails',
      'changeNotice',
      'changeNoticeDetail',
      'technicalIssuesCancelSelection',
      'technicalIssuesCancelDetails',
      'notificationMessage',
    ],
    changeReason: {
      'ui:widget': 'radio',
    },
    providerInitiated: {
      'ui:widget': 'radio',
    },
    providerInitiatedDetails: {
      'ui:widget': 'textarea',
    },
    changeNotice: {
      'ui:widget': 'radio',
    },
    changeNoticeDetail: {
      'ui:widget': 'radio',
    },
    technicalIssuesCancelSelection: {
      'ui:widget': 'radio',
      'ui:options': { styleType: '' },
    },
    technicalIssuesCancelDetails: {
      'ui:widget': 'textarea',
    },
  },
})
